/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/megaphone
 */
import { default as DefaultIcon } from '~icons/lucide/megaphone';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const MegaphoneIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
